import { createApp } from 'vue'

import FormBuilder from './components/FormBuilder'

document.querySelectorAll('.form-builder')
    .forEach(container => createApp()
        .component('FormBuilder', FormBuilder)
        .mount(container)
    )
